module.exports = ":host /deep/ .datepicker-input .custom-select {\n  width: 50%; }\n"